import { MessageCircle } from "lucide-react";

const FloatingChatButton = () => {
  return (
    <a
      href="https://wa.me/12027042459?text=Hello%20Goldspot%20Tax%2C%20I%20need%20help%20with%20my%20taxes."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 group"
      aria-label="Chat with us on WhatsApp"
      data-testid="floating-whatsapp-btn"
    >
      <span className="absolute inset-0 inline-flex h-full w-full rounded-full bg-[#25D366] opacity-30 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-black shadow-lg shadow-[#25D366]/30 transition-transform duration-300 group-hover:scale-110">
        <MessageCircle size={26} />
      </span>
    </a>
  );
};

export default FloatingChatButton;
